import _toConsumableArray from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.filter.js";
import { getViewinfo, getViewMetadata } from '@/api/viewinfo';
import { getCustomizeLinesList } from '@/api/customizeLines';
import { getHcTplListByTeam } from '@/api/biz_hc_tpl';
import { toTreeNode } from '@/utils/viewinfo';
import i18n from '@/i18n.js';
var getLinePath = function getLinePath(line) {
  var paths = [];
  if (line.children && line.children.length > 0) {
    line.children.forEach(function (child) {
      var arr = getLinePath(child);
      arr.forEach(function (val) {
        val.get('value').unshift(line.value);
        val.get('label').unshift(line.label);
        paths.push(val);
      });
    });
  } else {
    var map = new Map();
    map.set('value', [line.value]);
    map.set('label', [line.label]);
    paths.push(map);
  }
  return paths;
};
var getName = function getName(metadataMap, id) {
  var label;
  if (i18n.locale == 'cn') {
    label = metadataMap.get(id) && metadataMap.get(id).viDes || '其它';
  } else {
    label = metadataMap.get(id) && metadataMap.get(id).viNameEn || 'Other';
  }
  return label;
};
export var viewinfo = {
  namespaced: true,
  state: {
    viewMap: new Map(),
    customLineMap: new Map(),
    lineMap: new Map(),
    selectedNames: [],
    tplMap: new Map(),
    lang: ''
  },
  mutations: {
    setViewMap: function setViewMap(state, viewMap) {
      state.viewMap = viewMap;
    },
    setCustomLineMap: function setCustomLineMap(state, customLineMap) {
      state.customLineMap = customLineMap;
    },
    setLineMap: function setLineMap(state, lineMap) {
      state.lineMap = lineMap;
    },
    setSelectedNames: function setSelectedNames(state, names) {
      state.selectedNames = names;
    },
    setTplMap: function setTplMap(state, tplMap) {
      state.tplMap = tplMap;
    }
  },
  actions: {
    // 从后台获取view
    getViewinfoList: function getViewinfoList(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, viewMap, res, metadata, metadataMap, views, overseasId, keyMap, nameMap, specialCountryMap, continentMap, countryMap, ispMap, ispProvinceMap, continentNodes, ispCountry, ispProvinceCountry, continentNodes1, countries;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.viewMap.size != 0 && state.lang === i18n.locale)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", state.viewMap);
            case 5:
              state.lang = i18n.locale;
              viewMap = new Map();
              _context.next = 9;
              return getViewinfo();
            case 9:
              res = _context.sent;
              _context.next = 12;
              return getViewMetadata();
            case 12:
              metadata = _context.sent;
              if (res.code == 0 && metadata.code == 0) {
                metadataMap = new Map();
                metadata.data.lines.forEach(function (val) {
                  metadataMap.set(val.viId, val);
                });
                views = res.data.lines;
                overseasId = 0;
                keyMap = new Map();
                nameMap = new Map();
                specialCountryMap = [];
                views.forEach(function (val) {
                  if (val.viName == 'overseas-_-_-_') {
                    overseasId = val.viId;
                  } else {
                    var nameArr = val.viName.split('-');
                    if (nameArr.length == 4 && nameArr[3] == 'all') {
                      specialCountryMap.push(nameArr[0]);
                    }
                  }
                  keyMap.set(val.viId, val.viName);
                  nameMap.set(val.viName, val.viDes);
                });

                // continent
                continentMap = new Map(); // country
                countryMap = new Map(); // isp
                ispMap = new Map();
                ispMap.set('isp', []);
                // isp_province
                ispProvinceMap = new Map();
                ispProvinceMap.set('isp_province', []);
                continentNodes = [];
                ispCountry = [];
                ispProvinceCountry = [];
                views.forEach(function (val) {
                  var nameArr = val.viName.split('-');
                  if (val.viName == 'china-_-_-all' || val.viName == 'overseas-_-_-_' || val.viName == 'other-_-_-_' || nameArr.length != 4 || val.viDes.indexOf('大区') != -1 || val.viName.indexOf('custom') != -1 || val.viDes == '中国有线通' || val.viDes == '中国方正宽带' || val.viDes == '中国华数' || val.viDes == '中国歌华' || val.viDes == '中国广电' || val.viDes == '中国科技网' || val.viDes == '中国山东青岛其他' || nameArr[1] == 'rall' || nameArr[1] == 'rother' || nameArr[1] == 'rsouth') {
                    return true;
                  }
                  var node = {
                    value: val.viName,
                    label: val.viDes,
                    leaf: true
                  };
                  // 海外
                  if (val.viAreaid == overseasId) {
                    // node.label = node.label.replace('其他', '')
                    node.label = getName(metadataMap, val.viContinentid);
                    continentNodes.push(node);
                  } else if (nameArr[1] == '_' && (nameArr[3] == '_' || nameArr[3] == 'all')) {
                    if (nameArr[3] == '_' && specialCountryMap.indexOf(nameArr[0]) != -1) {
                      var key = nameArr[0] + '-_-_-all';

                      // let pName = nameMap.get(key).replace('all', '')
                      // node.label = node.label.replace(pName, '')
                      // other
                      node.label = getName(metadataMap, val.viIspid);
                      if (ispMap.has(key)) {
                        ispMap.get(key).push(node);
                      } else {
                        var isps = [node];
                        ispMap.set(key, isps);
                      }
                      return true;
                    }
                    node.label = getName(metadataMap, val.viCountryid);
                    var continent = keyMap.get(val.viAreaid);
                    if (countryMap.has(continent)) {
                      countryMap.get(continent).push(node);
                    } else {
                      var _countries = [node];
                      countryMap.set(continent, _countries);
                    }
                  } else if (nameArr[1] == '_' && nameArr[3] != '_') {
                    var _key = nameArr[0] + '-_-_-_';
                    if (specialCountryMap.indexOf(nameArr[0]) != -1) {
                      _key = nameArr[0] + '-_-_-all';
                    }

                    // let pName = nameMap.get(key).replace('all', '')
                    // node.label = node.label.replace(pName, '')
                    node.label = getName(metadataMap, val.viIspid);
                    if (ispMap.has(_key)) {
                      ispMap.get(_key).push(node);
                    } else {
                      var _isps = [node];
                      ispMap.set(_key, _isps);
                    }
                    if (ispCountry.indexOf(_key) == -1) {
                      var countryNode = {
                        value: _key,
                        label: getName(metadataMap, val.viCountryid)
                      };
                      ispMap.get('isp').push(countryNode);
                      ispCountry.push(_key);
                    }
                  } else if (nameArr[1] != '_') {
                    // if(specialCountryMap.indexOf(nameArr[0]) == -1){
                    //     return true
                    // }
                    if (val.viProid == 0) {
                      return true;
                    }
                    var _key2 = nameArr[0] + '-_-_-' + nameArr[3];
                    node.label = getName(metadataMap, val.viProid);
                    if (ispProvinceMap.has(_key2)) {
                      ispProvinceMap.get(_key2).push(node);
                    } else {
                      var ispProvinces = [node];
                      ispProvinceMap.set(_key2, ispProvinces);
                    }
                    if (ispProvinceCountry.indexOf(nameArr[0]) == -1) {
                      ispProvinceCountry.push(nameArr[0]);
                    }
                  }
                });

                // continent
                continentMap.set('continent', continentNodes);
                viewMap.set('continent', continentMap);

                // country
                continentNodes1 = [];
                continentNodes.map(function (item) {
                  var node = {
                    value: item.value,
                    label: item.label,
                    leaf: false
                  };
                  continentNodes1.push(node);
                });
                countryMap.set('country', continentNodes1);
                viewMap.set('country', countryMap);

                // isp
                viewMap.set('isp', ispMap);

                // isp_province
                countries = [];
                ispMap.forEach(function (val, key) {
                  var isps = [];
                  val.forEach(function (item) {
                    var nameArr = item.value.split('-');
                    var node = {
                      value: item.value,
                      label: item.label,
                      leaf: false
                    };
                    if (key != 'isp') {
                      isps.push(node);
                    } else {
                      var idx = ispProvinceCountry.indexOf(nameArr[0]);
                      if (idx != -1) {
                        countries.push(node);
                        // 剩余的可能是只有省，没有运营商的情况
                        ispProvinceCountry.splice(idx, 1);
                      }
                    }
                  });
                  ispProvinceMap.set(key, isps);
                });

                // isp_province, 有省，没有运营商的情况
                // console.log(ispProvinceCountry)
                ispProvinceCountry.forEach(function (country) {
                  countryMap.forEach(function (val) {
                    val.forEach(function (item) {
                      var nameArr = item.value.split('-');
                      if (nameArr[0] == country) {
                        var node = {
                          value: item.value,
                          label: item.label,
                          leaf: false
                        };
                        countries.push(node);

                        // 省没有运营商的，增加一个“其它”运营商
                        // 新增新的Node，ispProvinceMap 新增 unitedstates-_-_-_ => Node{unitedstates-_-_-other}
                        // ispProvinceMap中 新增 unitedstates-_-_-other => Array(51)
                        // 将原来的 ispProvinceMap中 unitedstates-_-_-_ => Array(51) 改为 => Array(1) 即 Arryay{ unitedstates-_-_-other }
                        // 所以变成  unitedstates-_-_-_ => unitedstates-_-_-other =>  Array(51)
                        nameArr[3] = "other";
                        var fakeKey = nameArr.join('-');
                        ispProvinceMap.set(fakeKey, ispProvinceMap.get(item.value));
                        var fakeNode = {
                          value: fakeKey,
                          label: getName(metadataMap, 0),
                          leaf: false
                        };
                        ispProvinceMap.set(item.value, [fakeNode]);
                      }
                    });
                  });
                });
                ispProvinceMap.set('isp_province', countries);
                viewMap.set('isp_province', ispProvinceMap);

                // console.log(viewMap)

                commit("setViewMap", viewMap);
              }
              return _context.abrupt("return", viewMap);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 从后台获取自定义线路
    getCustomLineMap: function getCustomLineMap(_ref2, zone) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var commit, state, res, customLineMap, lines, list;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit, state = _ref2.state;
              if (!state.customLineMap.has(zone)) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", state.customLineMap.get(zone));
            case 5:
              _context2.next = 7;
              return getCustomizeLinesList({
                'zone': zone
              });
            case 7:
              res = _context2.sent;
              customLineMap = new Map();
              lines = [];
              if (res.code == 0) {
                list = res.data.customizelines;
                if (list) {
                  list.forEach(function (val) {
                    var node = {
                      value: val.ipseg_name,
                      label: val.ipseg_name,
                      leaf: true
                    };
                    lines.push(node);
                  });
                }
                customLineMap.set(zone, lines);
              }
              commit("setCustomLineMap", customLineMap);
              return _context2.abrupt("return", lines);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getRecordLines: function getRecordLines(_ref3, zone) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var commit, state, dispatch, viewMap, lines, customerLines, viewinfoMap, lineLabelMap, infoMap, lineStr, lineMap;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit, state = _ref3.state, dispatch = _ref3.dispatch;
              if (!(state.lineMap.has(zone) && state.lang === i18n.locale)) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return", state.lineMap.get(zone));
            case 5:
              _context3.next = 7;
              return dispatch('getViewinfoList');
            case 7:
              viewMap = _context3.sent;
              lines = [{
                value: 'default',
                label: i18n.t('view.default')
              }, {
                value: 'common',
                label: i18n.t('view.common'),
                children: [{
                  value: 'china-_-_-all',
                  label: i18n.t('view.china-mainland'),
                  leaf: true
                }, {
                  value: 'overseas-_-_-_',
                  label: i18n.t('view.overseas'),
                  leaf: true
                }]
              }];
              viewMap.forEach(function (val, key) {
                var label = '';
                if (key == 'continent') {
                  label = i18n.t('view.continent');
                } else if (key == 'country') {
                  label = i18n.t('view.country');
                } else if (key == 'isp') {
                  label = i18n.t('view.isp');
                } else if (key == 'isp_province') {
                  label = i18n.t('view.isp-province');
                }
                var node = {
                  value: key,
                  label: label
                };
                toTreeNode(node, val);
                lines.push(node);
              });
              _context3.next = 12;
              return dispatch('getCustomLineMap', zone);
            case 12:
              customerLines = _context3.sent;
              lines.push({
                value: 'custom',
                label: i18n.t('view.custom'),
                children: customerLines
              });
              viewinfoMap = new Map();
              lineLabelMap = new Map();
              lines.forEach(function (line) {
                var paths = getLinePath(line);
                paths.forEach(function (path) {
                  var values = path.get('value');
                  var labels = path.get('label');
                  viewinfoMap.set(values[values.length - 1], values);
                  lineLabelMap.set(values[values.length - 1], labels);
                });
              });
              infoMap = new Map();
              infoMap.set('viewinfoMap', viewinfoMap);
              infoMap.set('lineLabelMap', lineLabelMap);
              lineStr = JSON.stringify(lines);
              infoMap.set('lines', lineStr);
              lineMap = new Map();
              lineMap.set(zone, infoMap);
              commit("setLineMap", lineMap);
              return _context3.abrupt("return", infoMap);
            case 26:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    setSelectedNames: function setSelectedNames(_ref4, _ref5) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var commit, state, addNames, removeNames, selectedNames, newSelectedNames;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit, state = _ref4.state;
              addNames = _ref5.addNames, removeNames = _ref5.removeNames;
              selectedNames = state.selectedNames;
              addNames.forEach(function (name) {
                if (selectedNames.indexOf(name) == -1) {
                  selectedNames.push(name);
                }
              });
              newSelectedNames = selectedNames;
              if (removeNames.length > 0) {
                newSelectedNames = _toConsumableArray(selectedNames).filter(function (x) {
                  return _toConsumableArray(removeNames).every(function (y) {
                    return y !== x;
                  });
                });
              }
              commit('setSelectedNames', newSelectedNames);
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    clearSelectedNames: function clearSelectedNames(_ref6) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var commit;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref6.commit;
              commit('setSelectedNames', []);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    updateRecordLines: function updateRecordLines(_ref7, zone) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var commit, dispatch;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref7.commit, dispatch = _ref7.dispatch;
              commit('setCustomLineMap', new Map());
              commit('setLineMap', new Map());
              _context6.next = 5;
              return dispatch('getRecordLines', zone);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getTplMap: function getTplMap(_ref8) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var commit, state, res, tplMap;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref8.commit, state = _ref8.state;
              if (!(state.tplMap.size != 0)) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return", state.tplMap);
            case 5:
              _context7.next = 7;
              return getHcTplListByTeam();
            case 7:
              res = _context7.sent;
              tplMap = new Map();
              if (res.code == 0 && res.data && res.data.list) {
                res.data.list.forEach(function (val) {
                  tplMap.set(val.ID, val);
                });
              }
              commit("setTplMap", tplMap);
              return _context7.abrupt("return", tplMap);
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    updateTplMap: function updateTplMap(_ref9) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var commit;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              commit = _ref9.commit;
              commit('setTplMap', new Map());
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    }
  },
  getters: {
    getViewMap: function getViewMap(state) {
      return state.viewMap;
    },
    getCustomLineMap: function getCustomLineMap(state) {
      return state.customLineMap;
    },
    getLineMap: function getLineMap(state) {
      return state.lineMap;
    },
    getSelectedNames: function getSelectedNames(state) {
      return state.selectedNames;
    },
    getTplMap: function getTplMap(state) {
      return state.tplMap;
    }
  }
};